import { cn } from '@/lib/utils'
import { Github, Linkedin, Globe } from 'lucide-react'
import { Typography } from '@/components/ui/typography'
import { IconWithTooltip } from '@/components/ui/icon-with-tooltip'
import { motion } from '@/components/ui/motion-provider'

interface FooterProps {
  className?: string
}

export function Footer({ className }: FooterProps) {
  const currentYear = new Date().getFullYear()

  return (
    <footer 
      className={cn(
        'w-full border-t border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60',
        'py-6 sm:py-8',
        'relative z-10',
        className
      )}
    >
      <div className="container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-6">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="flex flex-col sm:flex-row items-center sm:items-start gap-2 sm:gap-4"
          >
            <Typography variant="muted" className="text-center sm:text-left">
              © {currentYear} DevFinder by{' '}
              <a 
                href="https://sourcingdenis.live" 
                target="_blank" 
                rel="noopener noreferrer"
                className="font-medium text-primary/80 hover:text-primary transition-colors"
              >
                @sourcingdenis
              </a>
            </Typography>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="flex items-center space-x-4"
          >
            <IconWithTooltip
              icon={
                <a 
                  href="https://github.com/sinedied" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors group"
                >
                  <Github className="h-5 w-5 group-hover:scale-110 transition-transform" />
                </a>
              }
              tooltip="GitHub"
              isClickable
            />
            
            <IconWithTooltip
              icon={
                <a 
                  href="https://www.linkedin.com/in/dprotopopov/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors group"
                >
                  <Linkedin className="h-5 w-5 group-hover:scale-110 transition-transform" />
                </a>
              }
              tooltip="LinkedIn"
              isClickable
            />

            <IconWithTooltip
              icon={
                <a 
                  href="https://sourcingdenis.live" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-muted-foreground hover:text-primary transition-colors group"
                >
                  <Globe className="h-5 w-5 group-hover:scale-110 transition-transform" />
                </a>
              }
              tooltip="Portfolio"
              isClickable
            />
          </motion.div>
        </div>
      </div>
    </footer>
  )
}
